var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        accordion: true,
        'accordion--no-hover': _vm.noHover,
        'accordion--no-transition': _vm.noTransition,
        'is-expanded': _vm.isExpanded,
    }},[_c('div',{staticClass:"accordion__wrapper"},[_c('button',{staticClass:"accordion__title ts--body ts-align--left ts-weight--400 color--grey-900",attrs:{"type":"button"},on:{"click":function($event){return _vm.toggle($event)}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('figure',{staticClass:"accordion__arrow"},[_c('icon',{attrs:{"name":"generic-chevron-bottom"}})],1)]),_c('div',{class:{
                accordion__description: true,
                'accordion__description--text': _vm.isText,
            }},[_c('div',{staticClass:"accordion__description-inner"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }